import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Home, Login, Users, ForgotPassword, ResetPassword, Setting, Maps, Devices } from '../Screens'
import { MenuLayout } from '../Components'
import allPaths from './paths'
import { Result, Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { setLanguage } from '../Redux/actions/languageActions'

const Page404 = (props) => {
  const { history } = props
  return (
    <Result
      status='404'
      title='404'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <Button
          type='primary'
          className='form-button'
          onClick={() => history.push(allPaths?.HOME)}
        >
          Back Home
        </Button>
      }
    />
  )
}

const Routes = () => {
  const dispatch = useDispatch()
  const user = useSelector(state => state.authReducer.user)
  const language = useSelector(state => state.language.language)
  useEffect(() => {
    if (!language) {
      dispatch(setLanguage('it'))
    }
  }, [dispatch, language])

  return (
    <Router>
      <Switch>

        <Route path={allPaths?.LOGIN} language={language} setLanguage={setLanguage} exact component={Login} />
        <MenuLayout path={allPaths?.HOME} language={language} setLanguage={setLanguage} exact component={Home} />
        <MenuLayout path={allPaths?.USER} language={language} exact component={Users} />
        <MenuLayout path={allPaths?.DEVICES} language={language} exact component={Devices} />
        <MenuLayout path={allPaths?.PROFILE} language={language} exact component={Setting} />
        <MenuLayout path={allPaths?.MAP} language={language} exact component={Maps} />
        <Route path={allPaths?.FORGOT_PASSWORD} exact component={ForgotPassword} />
        <Route path={`${allPaths?.RESET_PASSWORD}/:token`} exact component={ResetPassword} />
        <Route path='*' exact component={Page404} />
      </Switch>
    </Router>
  )
}

export { Routes, Page404 }
